import React from 'react';

export function StatsCard({ title, value, icon: Icon, color = 'var(--brand-500)' }) {
  return (
    <div className="stat-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <div className="stat-card-title">{title}</div>
          <div className="stat-card-value">{value}</div>
        </div>
        {Icon && (
          <div style={{
            backgroundColor: `${color}15`,
            padding: 10,
            borderRadius: 8
          }}>
            <Icon size={24} color={color} />
          </div>
        )}
      </div>
    </div>
  );
}
